import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/monocle-gallery/layouts/default.vue").then(m => m.default || m)),
  "form-layout": defineAsyncComponent(() => import("/app/monocle-gallery/layouts/form-layout.vue").then(m => m.default || m)),
  "payment-layout": defineAsyncComponent(() => import("/app/monocle-gallery/layouts/paymentLayout.vue").then(m => m.default || m)),
  viewer: defineAsyncComponent(() => import("/app/monocle-gallery/layouts/viewer.vue").then(m => m.default || m))
}